import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RootComponent } from './root/root/root.component';
import { FormsModule } from '@angular/forms';
import { routing }  from './video.routing';
import { SharedModule } from '@shared/shared.module';
import { VideosComponent } from './pages/videos/videos.component';
import { AuthGuard } from '@core/guards/auth.guard';
import { VideoService } from './services/video.service';
import { VideosTutorialPortalComponent } from './pages/videos-tutorial-portal/videos-tutorial-portal.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    routing,
    SharedModule
  ],
  declarations: [
    VideosComponent,
    RootComponent,
    VideosTutorialPortalComponent,
  ],
  providers: [AuthGuard, VideoService]
})
export class VideoModule { }
